const content = {
  growthFQ: {
    title: "+{growth} FQ Growth",
    status: {
      qualified: "Congrats, you've met the +{growth} FQ Growth requirement!",
      tracking: "You're on track to meet the +{growth} FQ Growth requirement.",
      notQualified: "You're not tracking to meet the +{growth} FQ Growth requirement.",
    },
    baseline: "PY{perfYear} Baseline",
    ytdFqs: "Current YTD FQs",
    growthTracking: "+{growth} FQ Tracking",
    maintainTracking: "Maintain FQ Tracking",
  },
  annualGPV: {
    title: "Maintain FQs & Grow {target} Annual GPV",
    tooltip: "Maintain your FQs and grow your Annual GPV to meet this requirement.",
    status: {
      qualified: "Congrats, you've met the maintain FQs & grow {target} Annual GPV requirement!",
      tracking: "You're on track to meet the maintain FQs & grow {target} Annual GPV requirement.",
      notQualified: "You're not tracking to meet the maintain FQs & grow {target} Annual GPV requirement.",
    },
    baseline: "Baseline Annual GPV",
    requiredGPV: "Required GPV for PY{perfYear} with Growth Requirement",
    gpvYtd: "GPV YTD",
    projected: "Projected Annual GPV",
    description:
      "To stay on track to meet the required annual GPV, your desired target is an average of {monthlyTarget} GPV per month. Use the dial to see how you're tracking for the performance year.",
  },
  divider: "OR",
  accessibility: {
    iconMet: "Requirement met",
    iconNotMet: "Requirement not met",
  },
};

export default content;
